import { safeLocalStorage } from '@/lib/safeStorage';
import {jwtDecode} from 'jwt-decode';
import {AUTH_EVENTS, STORAGE_KEYS} from '../constants';

// =====================
// Session Management
// =====================

// Global reference to the customer session expired trigger function
// This will be set by the SessionExpiredProvider when it mounts
let globalCustomerSessionExpiredTrigger: (() => void) | null = null;

export function setSessionExpiredTrigger(trigger: (() => void) | null) {
  globalCustomerSessionExpiredTrigger = trigger;
}

export function handleCustomerSessionExpired() {
  if (globalCustomerSessionExpiredTrigger) {
    globalCustomerSessionExpiredTrigger();
  }
}

// =====================
// Token Management
// =====================

export function storeTokens({ idToken, accessToken, refreshToken }: { idToken: string, accessToken: string, refreshToken: string }) {
  console.log('[storeTokens] Storing new tokens');
  safeLocalStorage.setItem(STORAGE_KEYS.ID_TOKEN, idToken);
  safeLocalStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
  safeLocalStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);

  // Dispatch a custom event to notify auth status hook
  console.log('[storeTokens] Dispatching tokensUpdated event');
  window.dispatchEvent(new CustomEvent(AUTH_EVENTS.TOKENS_UPDATED));
}

export function getIdToken(): string | null {
  const token = safeLocalStorage.getItem(STORAGE_KEYS.ID_TOKEN);
  console.log('[getIdToken] Retrieved token:', token ? `${token.substring(0, 50)}...` : 'null');
  
  if (token) {
    try {
      const decoded = jwtDecode<any>(token);
      const isExpired = decoded.exp * 1000 < Date.now();
      console.log('[getIdToken] Token validation:', {
        isExpired,
        exp: new Date(decoded.exp * 1000).toISOString(),
        role: decoded['custom:role'],
        orgId: decoded['custom:orgId'],
        customerId: decoded['custom:customerId'],
        aud: decoded.aud,
        token_use: decoded.token_use
      });
      
      if (isExpired) {
        console.log('[getIdToken] Token is expired, returning null');
        return null;
      }
    } catch (error) {
      console.error('[getIdToken] Error decoding token:', error);
      return null;
    }
  }
  
  return token;
}

export function getAccessToken(): string | null {
  return safeLocalStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
}

export function getRefreshToken(): string | null {
  return safeLocalStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
}

export function clearTokens() {
  safeLocalStorage.removeItem('ruta_sign_in_method');
  safeLocalStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
  safeLocalStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  safeLocalStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
}

export function getProfile(): Record<string, any> | null {
  const idToken = getIdToken();
  if (!idToken) return null;
  try {
    return jwtDecode(idToken);
  } catch {
    return null;
  }
}

// Token refresh function moved to routes/auth.ts
